import React, { useEffect, useState, Suspense } from 'react';
import ImageCompare from '../components/ImageCompareHome.jsx';
import VideoMain from '../components/VideoMain';
import Benefits from '../components/Benefits';
import ABtesting from '../components/ABtesting';
import GlyphSvg from '../components/Glyphs';
import IntroBlock from '../components/IntroBlock';
import TextBlock from '../components/TextBlock';
import Varipose from '../components/Varipose';
import { usePageTitle } from '../hooks/usePageTitle';

// Lazy load the heavy components
const WireframeGlobe = React.lazy(() => import('../components/WireframeGlobe'));

export default function Home() {
  usePageTitle({
    title: 'AI Avatar Generation',
    description: 'Create stunning AI-generated avatars with our advanced technology. Professional, customizable, and ready for any platform.',
    image: '/img/hero-avatar.jpg'
  });

  return (
    <>
      <VideoMain />
      <IntroBlock />
      <Varipose />
      <ImageCompare />
      <TextBlock />
      <Benefits />
      <ABtesting />
      <Suspense fallback={<div>Loading...</div>}>
        <WireframeGlobe />
      </Suspense>
    </>
  );
}